import _ from 'underscore';

export default function SitesService($location, $http, $q) {
  let partnerSites = [];
  let _defaultSites = [];

  return {
    defaultSites,
    findById,
    findEnabledSite,
    fromSearchParams,
    isSiteEnabled,
    fetchPartnerSites,
    setPartnerSites,
    partnerSites
  };

  function setPartnerSites(_partnerSites) {
    partnerSites = _partnerSites;
  }

  function defaultSites() {
    if (_defaultSites.length > 0) {
      return $q.resolve(_defaultSites);
    }

    return $http.get('/sites/default').then(({ data }) => {
      _defaultSites = data;
      return _defaultSites;
    });
  }

  function fetchPartnerSites() {
    if (partnerSites.length > 0) {
      return $q.resolve(partnerSites);
    }

    return $http.get('/partners/sites').then(({ data }) => {
      partnerSites = data;
      return partnerSites;
    });
  }

  function isSiteEnabled(site, isInstantPlay, isEnhancedAd) {
    if (!site) {
      return false;
    }

    if (isEnhancedAd) {
      return site.enhancedAdsEnabled;
    }

    if (isInstantPlay) {
      return site.instantPlayEnabled;
    }

    return true;
  }

  function findEnabledSite(site, isInstantPlay, isEnhancedAd) {
    if (isSiteEnabled(site, isInstantPlay, isEnhancedAd)) {
      return site;
    }

    for (let i = 0; i < partnerSites.length; i++) {
      if (isSiteEnabled(partnerSites[i], isInstantPlay, isEnhancedAd)) {
        return partnerSites[i];
      }
    }
  }

  function find(identifier) {
    if (!identifier) {
      return;
    }

    if (identifier.indexOf('/') >= 0) {
      return _.findWhere(partnerSites, { url: identifier });
    } else {
      if (identifier === 'foodnetwork') {
        // we had to remove food because it's buggy. hardcoding a fix for this
        identifier = 'skysports';
      }

      return _.findWhere(partnerSites, { key: identifier });
    }
  }

  function findById(id) {
    if (!id) {
      return;
    }

    return _.findWhere(partnerSites, { id });
  }

  // this is a bit much because we have to handle multiple ways of
  // setting sites. /embed uses a key from the old hard-coded days of
  // sites. iframed pub sites use an external url, and now we're using the
  // id for everything going forward.
  function fromSearchParams() {
    const params = $location.search();
    let siteId = params.siteId;
    const siteParam = params.siteName || params.site;
    const url = siteParam && decodeURIComponent(siteParam);
    let existingSite;

    if (siteId) {
      siteId = Number(siteId);
      existingSite = findById(siteId);
    } else {
      existingSite = find(url);
    }

    if (existingSite) {
      return existingSite;
    } else if (siteParam) {
      return buildExternalDemoSite(url, params.deviceType);
    }
  }

  function buildExternalDemoSite(url, deviceType = 'mobile') {
    return {
      url: decodeURIComponent(url),
      group: deviceType,
      instantPlayEnabled: true,
      isExternalDemo: true
    };
  }
}

SitesService.$inject = ['$location', '$http', '$q'];
